document.addEventListener('DOMContentLoaded', function () {
  const contactButton = document.querySelector('.contact-popup-button');
  const popupOverlay = document.querySelector('.popup-form-overlay');
  const closeButton = document.querySelector('.popup-close-button');

  if (contactButton && popupOverlay) {
    console.log('Popup and button found');
    contactButton.addEventListener('click', function () {
      popupOverlay.style.display = 'flex';
      document.body.classList.add('no-scroll');
    });
  }

  if (closeButton && popupOverlay) {
    closeButton.addEventListener('click', function () {
      popupOverlay.style.display = 'none';
      document.body.classList.remove('no-scroll');
    });
  }
});
